<template>
  <div class="list van-hairline--top">
    <van-empty v-if="noData" description="暂无数据" />
    <van-list
      v-model="loading"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :finished="finished"
      :finished-text="finishedText"
      @load="onLoad"
    >
      <div
        class="item van-hairline--bottom"
        v-for="item in list"
        :key="item.id"
      >
        <slot :row="item" />
      </div>
    </van-list>
  </div>
</template>
<script>
export default {
  name: 'UserList',
  props: {
    type: {
      type: String,
      default: ''
    },
    requestFn: {
      type: Function,
      require: true
    }
  },
  data () {
    return {
      loading: false,
      error: false,
      finished: false,
      finishedText: '没有更多了',
      list: [],
      page: 1,
      per_page: 10,
      noData: false
    }
  },
  methods: {
    reset () {
      this.finished = false
      this.list = []
      this.page = 1
      this.noData = false
      this.error = false
      this.onLoad()
    },
    onLoad () {
      this.loading = true
      this.requestFn(this.page, this.per_page)
        .then((data) => {
          if (data.results.length) {
            this.list.push(...data.results)
            this.loading = false
            if (data.results.length < this.per_page) {
              this.finished = true
              this.finishedText = '没有更多了'
            } else {
              this.page++
            }
          } else {
            if (this.page === 1) {
              this.noData = true
              this.finishedText = ''
            } else {
              this.finishedText = '没有更多了'
            }
            this.finished = true
          }
        })
        .catch((e) => {
          this.error = true
          this.loading = false
        })
    }
  }
}
</script>
<style scoped lang="less">
.list {
  padding: 10px;
  .user-item {
    height: 78px;
    display: flex;
    align-items: center;
    .van-image {
      margin-right: 10px;
    }
    .info {
      flex: 1;
      p {
        &:first-child {
          font-size: 16px;
        }
        &:last-child {
          color: #999;
        }
      }
    }
    .van-button {
      width: 64px;
      height: 30px;
    }
  }
}
</style>
